import { useToast } from '@medely/ui-kit';
import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useResumeBuilderMutations = () => {
  const { axios } = useNetworkRequest();
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate: deleteEducation } = useMutation(
    (id?: number) => axios.delete(`/v3/professional/educations/${id}`),
    {
      onSuccess: () => {
        toast.success('Education deleted.'),
          {
            name: 'check',
          };
        queryClient.invalidateQueries(['GetEducationsForResumeBuilder']);
      },
      onError: () => {
        toast.error('Error on delete Education');
      },
    },
  );

  const { mutate: deleteWorkGap } = useMutation(
    (id?: number) => axios.delete(`/v3/professional/work_gaps/${id}`),
    {
      onSuccess: () => {
        toast.success('Work gap deleted'),
          {
            name: 'check',
          };
        queryClient.invalidateQueries(['GetWorkGapsForResumeBuilder']);
      },
      onError: () => {
        toast.error('Error on delete Work gap');
      },
    },
  );

  const { mutate: deleteWorkHistory } = useMutation(
    (id?: number) => axios.delete(`/v3/professional/work_histories/${id}`),
    {
      onSuccess: () => {
        toast.success('Work history deleted'),
          {
            name: 'check',
          };
        queryClient.invalidateQueries(['GetWorkHistoriesForResumeBuilder']);
      },
      onError: () => {
        toast.error('Error on delete Work history');
      },
    },
  );

  return {
    deleteEducation,
    deleteWorkGap,
    deleteWorkHistory,
  };
};
